import items from './items'

export default {
  getComments(id, params) {
    return items.getItems(`ratings/${id}/all_reviews_for_location`, params)
  },
}
